import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { ORGANISATION_CONTACTS_RESOURCE } from '../../constants';

const OrganisationContactsService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_CONTACTS_RESOURCE,
      method: 'get',
      request: id => ({
        url: apiRoutes.organisationContacts(id),
      }),
    },
  ])(ComposedComponent);

export default OrganisationContactsService;
